import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ECOM_PLATFORM_APP_DEF_ID, PageMap } from '../../utils/consts';
import { addWhiteListParamsToUrl } from '../../utils/whiteListParams';
import { isValidHttpUrl } from '../../utils/isValidHttpUrl';
export class NavigationService {
  constructor(controllerConfig, options) {
    this.controllerConfig = controllerConfig;
    _defineProperty(this, "continueShoppingUrl", void 0);
    _defineProperty(this, "successUrl", void 0);
    this.continueShoppingUrl = options == null ? void 0 : options.continueShoppingUrl;
    this.successUrl = options == null ? void 0 : options.successUrl;
  }
  async getThankYouPageUrlForPlaceOrder() {
    if (this.successUrl && isValidHttpUrl(this.successUrl)) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      return this.successUrl.replace('{objectType}', 'order');
    }
    const {
      url
    } = await this.getSectionUrl(PageMap.THANK_YOU_PAGE);
    const orderIdPlaceholder = 'orderIdPlaceholder';
    const thankYouPageUrl = new URL(`${url}/${orderIdPlaceholder}`);
    const appSectionParams = JSON.stringify({
      objectType: 'order',
      origin: 'checkout',
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      })
    });
    thankYouPageUrl.searchParams.set('appSectionParams', appSectionParams);
    addWhiteListParamsToUrl(thankYouPageUrl, this.controllerConfig.wixCodeApi.location.url);
    return thankYouPageUrl.toString().replace('orderIdPlaceholder', '{orderId}');
  }
  async getCheckoutErrorUrl(id, cashierPaymentId, contentAppId, contentComponentId) {
    const checkoutErrorUrl = await this.getCheckoutUrl(id, cashierPaymentId, contentAppId, contentComponentId);
    checkoutErrorUrl.searchParams.set('redirect', 'error');
    addWhiteListParamsToUrl(checkoutErrorUrl, this.controllerConfig.wixCodeApi.location.url);
    return checkoutErrorUrl.toString();
  }
  async getCheckoutCancelUrl(id, cashierPaymentId, contentAppId, contentComponentId) {
    const checkoutCancelUrl = await this.getCheckoutUrl(id, cashierPaymentId, contentAppId, contentComponentId);
    checkoutCancelUrl.searchParams.set('redirect', 'cancel');
    return checkoutCancelUrl.toString();
  }
  async navigateToThankYouPage(orderId) {
    var _this$controllerConfi, _this$controllerConfi2;
    if (this.successUrl && isValidHttpUrl(this.successUrl)) {
      return this.navigateToExternalSuccessPage(orderId);
    }
    const {
      url
    } = await this.getSectionUrl(PageMap.THANK_YOU_PAGE);
    const thankYouPageUrl = new URL(`${url}/${orderId}`);
    thankYouPageUrl.searchParams.set('appSectionParams', JSON.stringify({
      objectType: 'order',
      origin: 'cashier-express-directly-to-typ',
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      })
    }));
    return (_this$controllerConfi = (_this$controllerConfi2 = this.controllerConfig.wixCodeApi.location).to) == null ? void 0 : _this$controllerConfi.call(_this$controllerConfi2, thankYouPageUrl.toString());
  }
  navigateToExternalSuccessPage(orderId) {
    var _this$controllerConfi3, _this$controllerConfi4;
    const externalSuccessUrl = this.successUrl.replace('{orderId}', orderId).replace('{objectType}', 'order');
    return (_this$controllerConfi3 = (_this$controllerConfi4 = this.controllerConfig.wixCodeApi.location).to) == null ? void 0 : _this$controllerConfi3.call(_this$controllerConfi4, externalSuccessUrl);
  }
  async getCheckoutUrl(id, cashierPaymentId, contentAppId, contentComponentId) {
    const {
      url
    } = await this.getSectionUrl(PageMap.CHECKOUT);
    const checkoutUrl = new URL(url);
    const queryParams = {
      checkoutId: id,
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      }),
      ...(this.successUrl && {
        successUrl: this.successUrl.replace('{objectType}', 'order')
      }),
      cashierPaymentId,
      ...(contentAppId && /* istanbul ignore next */{
        contentAppId
      }),
      ...(contentComponentId && /* istanbul ignore next */{
        contentComponentId
      })
    };
    Object.entries(queryParams).forEach(_ref => {
      let [key, value] = _ref;
      checkoutUrl.searchParams.set(key, value);
    });
    addWhiteListParamsToUrl(checkoutUrl, this.controllerConfig.wixCodeApi.location.url);
    return checkoutUrl;
  }
  async navigateToCheckout(id, cashierPaymentId) {
    var _this$controllerConfi5, _this$controllerConfi6;
    const checkoutUrl = await this.getCheckoutUrl(id, cashierPaymentId);
    return (_this$controllerConfi5 = (_this$controllerConfi6 = this.controllerConfig.wixCodeApi.location).to) == null ? void 0 : _this$controllerConfi5.call(_this$controllerConfi6, checkoutUrl.toString());
  }
  getSectionUrl(sectionId) {
    const params = {
      sectionId,
      appDefinitionId: ECOM_PLATFORM_APP_DEF_ID
    };
    return this.controllerConfig.wixCodeApi.site.getSectionUrl(params, false);
  }
}
//# sourceMappingURL=NavigationService.js.map